// extracted by mini-css-extract-plugin
module.exports = {"container":"flash-banner__container___1kc4K","container--absolute":"flash-banner__container--absolute___32F3q"};